import React from "react";
import HeaderPortal from "components/portal/header-portal";
import { useFrillWidget } from "@/components/announcement/frill";
import { Icon } from "components";
import { Button } from "ui/components/button";
import { ANNOUNCEMENT } from "icons";

export default function WhatsNewButton() {
  const { unreadCount, toggleWidget, isLoading } = useFrillWidget();

  return (
    <HeaderPortal>
      <div className="relative inline-block">
        <Button
          onClick={toggleWidget}
          disabled={isLoading}
          variant="outline"
          className="cursor-pointer"
        >
          <Icon icon={ANNOUNCEMENT} className="size-5" />
          <span>What's New</span>
        </Button>
        {unreadCount > 0 && (
          <span className="absolute -top-2 -right-1 flex h-6 w-6 items-center justify-center pointer-events-none">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-6 w-6 bg-red-500 items-center justify-center text-xs font-bold text-white">
              {unreadCount > 9 ? "9+" : unreadCount}
            </span>
          </span>
        )}
      </div>
    </HeaderPortal>
  );
}
